// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stacked{
  top:0;
  transition: top ease 0.3s;
  position:relative;
  right:2px;
}
.stacked:hover {
  top: -10px;
}


.ticket {
  transition: all 0.4s ease-in-out;
}
.ticket:hover {
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);
}

.ticket-row {
  border-color:#edeff1;
  border-style: dashed;
  border:1px dashed #edeff1;
  transition: all 0.2s ease-in-out;
  vertical-align: center;

}

.ticket-row:hover{
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.ticket-table {
  width:90%;
  margin:auto;
  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);
}

.app_global_search{
  width: 320px;
  .search_input{
    font-size: 0.70rem;
  }
  .search_btn{
    width: 125px;
    font-size: 12px;
  }
}

.rounded-checkbox {
  border-radius: 50%!important;
  height:1rem!important;
  width:1rem!important;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
}

.rounded-checkbox:checked {
  background-color: #ff4613;
}


.modal-big {
  width:1200px;
}



.custom-window-class > .modal-dialog,
.custom-window-class > .modal-dialog > .modal-content {
  width: 1200px!important;
  max-width: 1200px!important;
  min-width: 1200px!important;
}










.tab {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.tab:after {
  content: '';
  display: block;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  position: absolute;
  background-color: #ff4612;
  transition: transform ease 200ms, opacity ease 0ms 200ms;
  transform: translateX(100%);
  opacity: 0;
}
.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {
  transform: translateX(-100%);
}
.tabs-wrapper:not(:hover) .tab:not(.active)::after {
  transform: translateY(100%);
}
.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {
  transition-delay: 0ms, 0ms;
}
.tab.active::after, .tab:hover::after {
  transform: translateX(0%);
  opacity: 1;
}

p.tab {
  display: inline-block;
  text-decoration: none;
  color: #000;
  padding: 1rem;
}



.avatar-box{
  display:table-cell;
  vertical-align:middle;

}
.avatar {
  display: table-cell;
  vertical-align:middle;
  border-radius: 50%;
  text-align: center;
  font-weight: 600;
  color: #fff;
}

.avatar-sm{
  width:2vw;
  height:2vw;
  font-size:1vw;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/containers/ticketing/components/teams/teams-table/teams-table-component.css"],"names":[],"mappings":"AAAA;EACE,KAAK;EACL,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,UAAU;AACZ;;;AAGA;EACE,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;;AAExB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,YAAY;AACd;;;;AAIA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;;;;;;;;;;AAWA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;EACxD,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;;;;AAIA;EACE,kBAAkB;EAClB,qBAAqB;;AAEvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA,wyJAAwyJ","sourcesContent":[".stacked{\n  top:0;\n  transition: top ease 0.3s;\n  position:relative;\n  right:2px;\n}\n.stacked:hover {\n  top: -10px;\n}\n\n\n.ticket {\n  transition: all 0.4s ease-in-out;\n}\n.ticket:hover {\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.15);\n}\n\n.ticket-row {\n  border-color:#edeff1;\n  border-style: dashed;\n  border:1px dashed #edeff1;\n  transition: all 0.2s ease-in-out;\n  vertical-align: center;\n\n}\n\n.ticket-row:hover{\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.ticket-table {\n  width:90%;\n  margin:auto;\n  box-shadow: 0px 0px 1rem rgba(0, 0, 0, 0.05);\n}\n\n.app_global_search{\n  width: 320px;\n  .search_input{\n    font-size: 0.70rem;\n  }\n  .search_btn{\n    width: 125px;\n    font-size: 12px;\n  }\n}\n\n.rounded-checkbox {\n  border-radius: 50%!important;\n  height:1rem!important;\n  width:1rem!important;\n  border: 1px solid #ddd;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n}\n\n.rounded-checkbox:checked {\n  background-color: #ff4613;\n}\n\n\n.modal-big {\n  width:1200px;\n}\n\n\n\n.custom-window-class > .modal-dialog,\n.custom-window-class > .modal-dialog > .modal-content {\n  width: 1200px!important;\n  max-width: 1200px!important;\n  min-width: 1200px!important;\n}\n\n\n\n\n\n\n\n\n\n\n.tab {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n.tab:after {\n  content: '';\n  display: block;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  position: absolute;\n  background-color: #ff4612;\n  transition: transform ease 200ms, opacity ease 0ms 200ms;\n  transform: translateX(100%);\n  opacity: 0;\n}\n.tabs-wrapper:hover .tabs:not(:hover) .tab:not(.active):first-child::after, .tab:hover ~ .tab:not(.active)::after {\n  transform: translateX(-100%);\n}\n.tabs-wrapper:not(:hover) .tab:not(.active)::after {\n  transform: translateY(100%);\n}\n.tabs:hover .tab:hover::after, .tabs-wrapper:hover .tabs:hover .tab:hover::after {\n  transition-delay: 0ms, 0ms;\n}\n.tab.active::after, .tab:hover::after {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\np.tab {\n  display: inline-block;\n  text-decoration: none;\n  color: #000;\n  padding: 1rem;\n}\n\n\n\n.avatar-box{\n  display:table-cell;\n  vertical-align:middle;\n\n}\n.avatar {\n  display: table-cell;\n  vertical-align:middle;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: 600;\n  color: #fff;\n}\n\n.avatar-sm{\n  width:2vw;\n  height:2vw;\n  font-size:1vw;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
